var nb = {
    close: 'Lukk',
};
var nn = {
    close: 'Lukk',
};
var en = {
    close: 'Close',
};
export var txt = { nb: nb, nn: nn, en: en };
